import BoxPosition from '..';

export default function toAbsoluteBoxPosition(
  from: BoxPosition,
  viewport: { width: number; height: number }
): BoxPosition {
  const x = from.x * viewport.width;
  const y = from.y * viewport.height;
  const width = from.width * viewport.width;
  const height = from.height * viewport.height;
  return { x, y, width, height };
}
